import React, { useState } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';
import { FileDrop } from 'react-file-drop';
import API from '../../api.js';

export default function ProjEditImageDomUtil(props) {
    const [tmpFile64, setTmpFile64] = useState(null);
    // const handleChangeStatus = ({ meta }, status) => {
    //     console.log(status, meta)
    // }

    function convertFile(file) {
        return new Promise((resolve, reject) => {
            // 建立FileReader物件
            let reader = new FileReader()
            // 註冊onload事件，取得result則resolve (會是一個Base64字串)
            reader.onload = () => { resolve(reader.result) }
            // 註冊onerror事件，若發生error則reject
            reader.onerror = () => { reject(reader.error) }
            // 讀取檔案
            reader.readAsDataURL(file)
        })
    }

    const fileToBase64 = (file) => {
        convertFile(file)
            .then(data => {
                // setTmpFile64(data);
                try {
                    let tmp = data.split(";")[0];
                    tmp = tmp.split("/")[1].toUpperCase();
                    onSend(tmp, data); //data.split(",")[1]
                } catch (e) {
                    console.error(e.stack);
                }
                // console.log(data) // 把編碼後的字串輸出到console
                // showPreviewImage(data, file.name)
            })
            .catch(err => console.error(err))
    }

    const onDrop = (files, event) => {
        console.log('onDrop!', files, event)
        if (files && files.length && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                fileToBase64(files[i]);
            }
        }
    }

    const onSend = (type, data) => {
        switch (type) {
            case "JPG":
            case "PNG":
            case "GIF":
                break;
            case "JPEG":
                // console.log("type switched: JPEG->JPG");
                type = "JPG";
                break;
            default:
                alert("非指定圖片類型:" + type + ",請重新上傳");
                return;
        }
        API.ImageUpload({}, {
            type: props.type, //0 : 專案, 1 : 廣告, 2 : 商品
            id: props.id,
            images: [
                {
                    imageType: type,
                    raw: data
                }
            ]
        })
            .then(response => {
                console.log(response);
                try {
                    if (response && response.responseData
                        && response.responseData.data) {
                        let data = response.responseData.data;
                        // let resultAry = data.map(a => a.url);
                        for (let i = 0; i < data.length; i++) {
                            console.log(data[i].name, data[i].url);
                        }

                        props.onChange(props.dataKey, data[0].url)
                    }
                } catch (e) {
                    console.warn(e.stack);
                }
            });
    }

    function render() {
        const { isDisabled, value } = props;
        // const { value } = this.state;
        const imgDom = value ? (
            <Col className="imageContainer">
                <img style={{ maxWidth: "100%" }} src={value} />
                {/* <input disabled="disabled" className="form-control" type="text" value={value} /> */}
            </Col>
        ) : (
            <Col className="imageContainer">
                <label className="empty">No Image</label>
            </Col>
        );
        const fileDom = tmpFile64 ? (
            <Col className="file-drop-container">
                <div><img src={tmpFile64} /></div>
                <Button onClick={onSend}>Send</Button>
            </Col>
        ) : (
            <Col className="file-drop-container">
                <FileDrop
                    // onFrameDragEnter={(event) => console.log('onFrameDragEnter', event)}
                    // onFrameDragLeave={(event) => console.log('onFrameDragLeave', event)}
                    // onFrameDrop={(event) => console.log('onFrameDrop', event)}
                    // onDragOver={(event) => console.log('onDragOver', event)}
                    // onDragLeave={(event) => console.log('onDragLeave', event)}
                    onDrop={onDrop} //(files, event) => console.log('onDrop!', files, event)}
                >
                    請拖放檔案至此
                </FileDrop>
            </Col>
        );

        if (isDisabled) {
            return (
                <Col className="projEditImage">
                    {imgDom}
                </Col>
            );
        } else {
            return (
                <Container>
                    <Row className="projEditImage">
                        {imgDom}
                        {fileDom}
                    </Row>
                </Container>
            );
        }
    }
    return render();
}